export default __webpack_public_path__ + "static/media/ghove_qazaeye_logo.4c05a3d0.png";